/**
 * =====================================================
 * Mining Survey WebGIS
 * Configuration
 * =====================================================
 */

const CONFIG = {
    APP: {
        NAME: "Mining Survey WebGIS",

        VERSION: "0.3.1",
    },

    MAP: {
        CENTER: [1.14410603, 117.87007012],

        ZOOM: 17,

        MIN_ZOOM: 3,

        MAX_ZOOM: 22,
    },

    GPS: {
        FOLLOW: false,

        FOLLOW_ZOOM: 18,

        ENABLE_HIGH_ACCURACY: true,

        TIMEOUT: 10000,

        MAXIMUM_AGE: 0,
    },

    TRACK: {
        MIN_DISTANCE: 0.5, // meter

        MAX_ACCURACY: 20, // meter

        MAX_SEGMENT: 30, // meter

        MAX_SPEED: 25, // km/h (mode jalan kaki)

        MAX_WALK_SPEED: 8, // km/h

        MAX_VEHICLE_SPEED: 80, // km/h
    },
};

export default CONFIG;
